export enum File {
  Image = 'image',
  Video = 'video',
}

export enum ImageFormat {
  Thumbnail = 'thumbnail',
  SmallWebp = 'small_webp',
  Small = 'small',
  MediumWebp = 'medium_webp',
  Medium = 'medium',
  LargeWebp = 'large_webp',
  Large = 'large',
}

export enum VideoFormat {
  Thumbnail = 'thumbnail',
  SdMp4 = 'sd_mp4',
  HdWebm = 'hd_webm',
  HdMp4 = 'hd_mp4',
  FullHdWebm = 'full_hd_webm',
  FullHdMp4 = 'full_hd_mp4',
}
